import { createSelector } from 'reselect';
import ComplianceResconConsignmentIdNotInPreconSummaryColumns from '../../containers/ComplianceResconConsignmentIdNotInPreconSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ComplianceResconConsignmentIdNotInPreconSummaryColumns);
